import Route from '@ember/routing/route'
import type Store from '@ember-data/store'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import type Student from 'teacher-ui-client/models/student'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type BookLibraryCollectionService from 'teacher-ui-client/services/book-library/collection'
import { task } from 'ember-concurrency'
import type Teacher from 'teacher-ui-client/models/teacher'

interface Params extends Record<string, unknown> {
  collectionId?: string
}

export default class BookLibrarySharesNewRoute extends Route {
  queryParams = {
    collectionId: {
      replace: true,
    },
    sort: {
      replace: true,
    },
    selected: {
      replace: true,
    },
    search: {
      replace: true,
    },
    grade: {
      replace: true,
    },
    schoolClass: {
      replace: true,
    },
    pageNumber: {
      replace: true,
    },
    perPage: {
      replace: true,
    },
  }

  @service('book-library/collection')
  collectionService!: BookLibraryCollectionService

  @service
  store!: Store

  @service
  session!: SessionService

  loadStudents = task(
    { drop: true },
    async (currentTeacher: Teacher, subscriptionType: SubscriptionType): Promise<Student[]> => {
      // Regardless of which students are needed - ensure all students are at least loaded with school classes, to know
      // which students belong to each class
      const allStudents = await this.store.query<Student>('student', {
        // @ts-expect-error - include types not correct
        include: 'school-classes',
      })

      // if subco, all students, else all students in that teachers' classes.
      if (currentTeacher.subcoFor(subscriptionType)) {
        // all students in the school
        return allStudents.slice()
      } else {
        // all students in teachers' classes
        return currentTeacher.studentsForSubscriptionType(subscriptionType)
      }
    },
  )

  model(params: Params) {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute

    const { currentTeacher } = this.session
    if (!currentTeacher) throw Error('current teacher is undefined')

    if (!params.collectionId) throw Error('collectionId not given')

    const loadCollection = this.collectionService.findCollection.perform(params.collectionId)
    const loadStudents = this.loadStudents.perform(currentTeacher, subscriptionType)

    return { subscriptionType, loadCollection, loadStudents }
  }
}
